<div
    class="tw-h-full tw-w-full tw-flex tw-justify-center tw-flex-col tw-relative tw-items-center"
>
    <button
        (click)="closeDialog()"
        class="tw-absolute tw-right-4 tw-top-4 tw-text-black tw-text-2xl tw-z-10"
        aria-label="Close dialog"
    >
        ✕
    </button>
    <div
        class="tw-max-w-[300px] tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-4 tw-text-center"
    >
        <svg
            class="tw-mb-2 lg:tw-mb-5"
            width="200"
            height="112"
            viewBox="0 0 200 112"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M200 112C200 99.9184 197.413 87.9551 192.388 76.7931C187.362 65.6312 179.997 55.4892 170.711 46.9462C161.425 38.4032 150.401 31.6265 138.268 27.0031C126.136 22.3796 113.132 20 100 20C86.8678 20 73.8642 22.3797 61.7317 27.0031C49.5991 31.6265 38.5752 38.4032 29.2893 46.9462C20.0035 55.4892 12.6375 65.6312 7.61204 76.7931C2.58657 87.9551 -1.14805e-06 99.9184 0 112L100 112H200Z"
                fill="#FFA53C"
                fill-opacity="0.56"
            />
            <circle cx="156" cy="26" r="26" fill="#95D1F3" />
        </svg>
        <h2
            class="!tw-mb-0 !tw-text-md !tw-leading-[1.5] lg:!tw-text-2xl !tw-font-bold"
        >
            {{ "REDEEM.TQ_TITLE" | translate }}
        </h2>
        <p
            class="tw-w-[177px] md:tw-w-full !tw-text-sm lg:!tw-text-[15px] !tw-text-[#2B2B2BCC]"
        >
            {{ "REDEEM.TQ_DESC" | translate }}
        </p>
    </div>
</div>
